// LiveCount.jsx
import React, { useEffect, useState, useRef } from "react";
import "./LiveCount.css";
import axios from "axios";
import config from "../config";
import { Link } from "react-router-dom"; 

const serverurl = config.apiUrl;

export default function LiveCount() {
  const [postCount, setPostCount] = useState(0);
  const [animatedCount, setAnimatedCount] = useState(0);

  // refs used for smooth animation and cleanup
  const rafRef = useRef(null);
  const startValueRef = useRef(0);
  const targetValueRef = useRef(0);
  const startTimeRef = useRef(null);

  // Fetch count from backend (initial + periodic)
  useEffect(() => {
    let isMounted = true;

    const getCount = async () => {
      try {
        const { data } = await axios.get(`${serverurl}/api/v1/getpostcount`);
        if (!isMounted) return;
        // defensively accept numeric count
        const count = Number(data.count) || 0;
        setPostCount(count);
      } catch (_) {
      }
    };

    getCount();
    const interval = setInterval(getCount, 10000); // every 10s

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  // Animate from current displayed value to latest postCount
  useEffect(() => {
    // cancel any running frame
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    }

    const from = Number(animatedCount) || 0; // start from current displayed value
    const to = Number(postCount) || 0;

    // if no change, nothing to do
    if (from === to) return;

    startValueRef.current = from;
    targetValueRef.current = to;
    startTimeRef.current = null;

    // duration can scale with delta but kept short
    const delta = Math.abs(to - from);
    const duration = Math.min(1400, Math.max(400, Math.floor(400 + delta * 0.6)));

    const step = (timestamp) => {
      if (!startTimeRef.current) startTimeRef.current = timestamp;
      const elapsed = timestamp - startTimeRef.current;
      const progress = Math.min(elapsed / duration, 1);

      // easeOutCubic for a pleasant finish
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(startValueRef.current + (to - startValueRef.current) * eased);

      setAnimatedCount(current);

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        rafRef.current = null;
        // ensure final value exactly matches
        setAnimatedCount(to);
      }
    };

    rafRef.current = requestAnimationFrame(step);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postCount]);

  return (
    <div className="live-count-page">
      <main className="live-count-card">
        <div className="count-area">
          <div className="count-number" aria-live="polite">
            {animatedCount.toLocaleString()}
          </div>
          <div className="count-label">records already created</div>
        </div>

        <p className="count-description">
          Are you ready for your turn? 
        </p>

        <div style={{ marginTop: "40px" }}>
        <Link to="/dashboard/new" className="btn-primary">
        Create record
        </Link>

      </div>
      </main>
    </div>
  );
}
